import { Col2 } from "react-native-col";

import {
  CheckboxInput,
  Col,
  Col1,
  NumberInput,
  PickerInput,
  Row,
  TextBody,
} from "../lib";
import { ServiceType } from "../services";
import { colors, createStyles } from "../theme";

const MULTIPLIER_OPTIONS = [
  { label: "1x", value: 1 },
  { label: "2x", value: 2 },
  { label: "3x", value: 3 },
];

type Props = {
  active?: boolean;
  id: number;
  name: string;
  description: string;
  type: ServiceType;
  onChangeValue: (id: string, value: number | null) => void;
  onToggle: (id: string, active: boolean) => void;
  value?: number;
};

export function ServiceInput({
  active = false,
  id,
  name,
  description,
  onChangeValue,
  onToggle,
  type,
  value = 0,
}: Props) {
  return (
    <Row.LR key={id} pb="4" mb="4" style={$.container}>
      <Col2>
        <CheckboxInput
          name={`${id}`}
          value={active}
          label={
            <Col ml="2">
              <TextBody em>{name}</TextBody>
              <TextBody color="onSurfaceDim">{description}</TextBody>
            </Col>
          }
          onChange={onToggle}
        />
      </Col2>
      <Col1>
        {type === "open" && (
          <NumberInput
            disabled={!active}
            name={`${id}`}
            value={value}
            onChange={onChangeValue}
            placeholder="Price"
          />
        )}
        {type === "multiplier" && (
          <PickerInput
            disabled={!active}
            name={`${id}`}
            value={value}
            onChange={onChangeValue}
            options={MULTIPLIER_OPTIONS}
          />
        )}
      </Col1>
    </Row.LR>
  );
}

const $ = createStyles({
  container: {
    borderBottomWidth: 1,
    borderBottomColor: colors.outline,
  },
});
